import { useTranslation } from "react-i18next";
import { Card3D } from "./Card3D";

// مخطط 12 شهر — أعمدة ملوّنة بروز 3D داخل حاوية Card3D.
export const TrendChart = ({ series }) => {
  const { t } = useTranslation();
  const peak = Math.max(...series.map((s) => Math.abs(Number(s.revenue))), 1);

  return (
    <Card3D titleKey="acct.trend12" testid="acct-trend">
      <div className="flex h-48 items-end gap-2" dir="ltr">
        {series.map((point) => {
          const h = Math.max((Math.abs(Number(point.revenue)) / peak) * 160, 4);
          return (
            <div key={point.month} className="flex flex-1 flex-col items-center gap-1"
                 data-testid={`trend-${point.month}`}>
              <div
                className="w-full rounded-t-xl bg-gradient-to-t from-primary/70 via-primary to-primary/85
                           transition-[height] duration-500"
                style={{
                  height: `${h}px`,
                  boxShadow: "inset 0 1px 0 rgba(255,255,255,0.35), 0 4px 8px rgba(0,0,0,0.30)",
                }}
              />
              <span className="font-mono text-[10px] font-bold text-muted-foreground">
                {point.month.slice(5)}
              </span>
            </div>
          );
        })}
      </div>
    </Card3D>
  );
};
